/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { itemTypeSchema } from "./itemTypeSchema.ts";

export const pluginPostbackItemRequestSchema = z.object({
	cookingPlaceId: z.uuid(),
	id: z.uuid(),
	cookingState: z.int(),
	type: itemTypeSchema.describe("* `food` - Еда\n* `drink` - Напиток"),
	name: z.string().min(1).max(100),
});
